import React, { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import {
  addNewCity,
  fetchProvincesByCountry,
  updateCity,
} from "../../services/axios/apiManager";
import { toast } from "sonner";
import LoadingSpinner from "../../Components/spinner";
import { useNavigate } from "react-router-dom";
import { handleErrors } from "../../services/dataManager";
import { Formik } from "formik";
import { cityValidationSchema } from "./cityValidations";

const AddEditCityModal = ({
  showModal,
  setShowModal,
  selectedCity,
  setSelectedCity,
  countriesList,
  fetchCities,
}) => {
  const navigate = useNavigate();
  const [provincesList, setProvincesList] = useState([]);
  const [loading, setLoading] = useState(true);

  const handleCloseAddEditModal = () => {
    setSelectedCity({});
    setProvincesList([]);
    setShowModal(false);
  };

  // // // fetch Provincesby Country id
  const getProvinces = async (id) => {
    const res = await fetchProvincesByCountry(id);
    if (res?.data?.success && res?.data?.data) {
      setProvincesList(res.data.data);
    } else {
      handleErrors(res, navigate, "Get Provinces:");
    }
  };

  const handleSubmitForm = async (data) => {
    setLoading(true);
    if (selectedCity?.id) {
      // // // Edit City

      const res = await updateCity({
        id: selectedCity.id,
        ...data,
      });
      if (res?.data?.success) {
        await fetchCities({ currentPage: 1, pageSize: 20 });
        toast.success("City has been updated.", { duration: 2000 });
        handleCloseAddEditModal();
      } else {
        handleErrors(res, navigate, "Update City:");
      }
    } else {
      // // // Add City
      const res = await addNewCity(data);
      if (res?.data?.success) {
        await fetchCities({ currentPage: 1, pageSize: 20 });
        toast.success("A new city has been added.", { duration: 2000 });
        handleCloseAddEditModal();
      } else {
        handleErrors(res, navigate, "Add City:");
      }
    }
    setLoading(false);
  };
  useEffect(() => {
    if (showModal && selectedCity?.country_id) {
      getProvinces(selectedCity.country_id);
    }
    setLoading(false);
  }, [showModal]);
  return (
    <Modal
      show={showModal}
      onHide={handleCloseAddEditModal}
      centered
      className="text-light"
      backdrop="static"
      size="lg"
    >
      <Modal.Header closeButton className="bg-dark text-light border-0">
        <Modal.Title>
          {selectedCity?.id ? "Edit City" : "Add New City"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="bg-dark text-light">
        <Formik
          initialValues={{
            city_name: selectedCity?.city_name || "",
            province_id: selectedCity?.province_id || "",
            country_id: selectedCity?.country_id || "",
          }}
          validationSchema={cityValidationSchema}
          onSubmit={async (values) => {
            try {
              setLoading(true);
              await handleSubmitForm(values);
            } catch (error) {
              console.log("Error upon Adding/Update Province", error);
            } finally {
              setLoading(false);
            }
          }}
        >
          {({
            handleChange,
            setFieldValue,
            handleSubmit,
            values,
            errors,
            touched,
          }) => (
            <div>
              <Form.Group className="mb-3">
                <Form.Label className="text-secondary">City Name</Form.Label>
                <Form.Control
                  type="text"
                  required
                  placeholder="Enter city name"
                  name="city_name"
                  value={values.city_name}
                  onChange={handleChange("city_name")}
                  className="bg-dark text-light border-light"
                />
                {errors?.city_name && touched?.city_name ? (
                  <span className="text-danger">{errors?.city_name}</span>
                ) : null}
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label className="text-secondary">
                  Select Country
                </Form.Label>
                <Form.Select
                  name="country_id"
                  required
                  value={values.country_id}
                  onChange={async (event) => {
                    setFieldValue("country_id", event.target.value);
                    setFieldValue("province_id", "");
                    await getProvinces(event.target.value);
                  }}
                  className="bg-dark text-light border-light"
                >
                  <option value="">Select a Country</option>
                  {countriesList?.map((country, index) => (
                    <option key={index} value={country.id}>
                      {country.country_name}
                    </option>
                  ))}
                </Form.Select>
                {errors?.country_id && touched?.country_id ? (
                  <span className="text-danger">{errors?.country_id}</span>
                ) : null}
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label className="text-secondary">
                  Select Province
                </Form.Label>
                <Form.Select
                  required
                  name="province_id"
                  value={values.province_id}
                  onChange={handleChange("province_id")}
                  className="bg-dark text-light border-light"
                >
                  <option value="">Select a Province</option>
                  {provincesList.map((prov, index) => (
                    <option key={index} value={prov.id}>
                      {prov.province_name}
                    </option>
                  ))}
                </Form.Select>
                {errors?.province_id && touched?.province_id ? (
                  <span className="text-danger">{errors?.province_id}</span>
                ) : null}
              </Form.Group>

              <div className="constainer-fluid">
                <div className="d-flex justify-content-end">
                  {loading && (
                    <div className="mt-4 mx-2">
                      <LoadingSpinner size={"lg"} />
                    </div>
                  )}
                  <Button
                    variant="secondary"
                    onClick={() => {
                      handleCloseAddEditModal();
                    }}
                    className="mt-3 mx-2"
                  >
                    Close
                  </Button>
                  <Button
                    variant="success"
                    className="mt-3"
                    onClick={() => {
                      handleSubmit();
                    }}
                  >
                    {selectedCity?.id ? "Update" : "Add City"}
                  </Button>
                </div>
              </div>
            </div>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  );
};

export default AddEditCityModal;
{
  /*  */
}
